import api from './api'

export default {
  async listar() {
    const response = await api.get('/itens-plano')
    return response.data
  },

  async criar(data) {
    const response = await api.post('/itens-plano', data)
    return response.data
  },

  async atualizar(id, data) {
    const response = await api.put(`/itens-plano/${id}`, data)
    return response.data
  }
}
